import React, { useContext } from 'react'

import ActionButton from 'uiComponents/buttons'
import { Col, Row } from 'uiComponents/flex'
import PricePreview from './pricePreview'
import { useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import ResetToDefault from './resetToDefault'
import RtpProductsWarning from './rtpProductsWarning'
import StudioContext from './provider/context'
import { DoNotEditSettingsWarningMessage } from './doNotEditWarning'
import './layout.scss'
import { Trans, useTranslation } from 'translations'

const GPSStudioLayout: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const { articles, isLoading } = useContext(StudioContext)

    return (
        <Row wrap="nowrap" className="gpsStudioLayout">
            <Col span="auto" style={{ flexGrow: 1, minWidth: 0 }}>
                <Row className="saveBar">
                    <Col span={12}>
                        <Row align="flex-end">
                            <Col span="auto">
                                <ActionButton type="submit" size="large">
                                    {t('common.save')}
                                </ActionButton>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={{ padding: '0 1rem 0 1.5rem' }}>
                    <Col span={12}>
                        <div className="header">
                            <h1>{t('globalPricingSettings.studio.layout.title')}</h1>
                            <div className="subtitle" role="doc-subtitle">
                                <Trans
                                    i18nKey="globalPricingSettings.studio.layout.subtitle"
                                    components={{
                                        anchor: (
                                            <a
                                                target="_blank"
                                                href="https://support.convious.com/help/how-to-use-advance-settings-to-fine-tune-pricing-factors"
                                                rel="noreferrer"
                                            />
                                        ),
                                    }}
                                />
                            </div>
                            <div className="messagesContainer">
                                <DoNotEditSettingsWarningMessage />
                                {!isLoading && articles.length === 0 && (
                                    <RtpProductsWarning accountSlug={accountSlug} />
                                )}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col span="auto" id="settings">
                        {children}
                    </Col>
                    <Col span="auto" id="sidePanel">
                        <aside>
                            <PricePreview />
                            <ResetToDefault />
                        </aside>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

export default GPSStudioLayout
